import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Autocomplete,
  IconButton,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  InputAdornment,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Tab,
  Switch,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import toast from "react-hot-toast";
import OptionTable from "./OptionTable";
import BannedSharesMarquee from "../../utils/BannedSharesMarquee";
import { axiosConfig } from "../../axios/axiosConfig";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  calculateExpectedProfit,
  getEntryValue,
  percentToStopLoss,
  percentToTarget,
  stopLossToPercent,
  targetToProfitPercent,
} from "../../utils/tradeCalculations";
import PaginationControls from "../../components/Pagination/PaginationControls";
import { formatSymbolName } from "./formatSymbolName";
import PnlWebSocketListener from "./PnlWebSocketListener";
const initialFormData = {
  script_name: "High Risk",
  instrument_type: 2,
  symbol_id: null,
  symbol_name: "",
  duration: "",
  lot_size: "",
  expire_date: "",
  stop_loss: "",
  stop_loss_percent: "",
  target_amount: "",

  trades: [
    {
      strike_price: "",
      order_type: "BUY",
      option_type: "",
      last_trading_price: "",
      entry_price_type: "FLAT",
      entry_price: null,
      entry_price_from: null,
      entry_price_to: null,
      expected_profit: null,
      profit_percent: "",
      price_selection_type: "BID",
      bid_type: "UPPER",
      valid_for_parrva: false,
    },
  ],
};

const OptionsDashboard = () => {
  const [openPreview, setOpenPreview] = useState(false);
  const [loadingSymbols, setLoadingSymbols] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [symbols, setSymbols] = useState([]);
  const [expiryDates, setExpiryDates] = useState([]);
  const [strikePrices, setStrikePrices] = useState([]);
  const [strikeMap, setStrikeMap] = useState({});
  const [expiryLoading, setExpiryLoading] = useState(false);
  const [strikeLoading, setStrikeLoading] = useState(false);
  const [futureOptionLoading, setFutureOptionLoading] = useState(false);
  const [futureOptionData, setFutureOptionData] = useState([]);
  const [selectedSymbolName, setSelectedSymbolName] = useState("");
  const [strikePricesMap, setStrikePricesMap] = useState({ CE: [], PE: [] });
  const [formData, setFormData] = useState(initialFormData);
  const [extraFields, setExtraFields] = useState([]);
  const isOption = formData.instrument_type === 2;
  const [autoRefresh, setAutoRefresh] = useState(false);
  const [tradeFilter, setTradeFilter] = useState(
    () => localStorage.getItem("option_tradeFilter") ?? "open"
  );
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [lastPnl, setLastPnl] = useState(null);
  const [cmpRefreshing, setCmpRefreshing] = useState(false);

  const offset = 50;
  console.log(formData, "formData");
  const handleWsPnlUpdate = useCallback((pnlUpdate) => {
    const wsTradeId = Number(pnlUpdate?.trade_id);
    if (!wsTradeId) {
      console.warn("💹 [WS] Invalid trade_id:", pnlUpdate?.trade_id);
      return;
    }

    setFutureOptionData((prev) => {
      if (!Array.isArray(prev)) return prev;

      const idx = prev.findIndex((row) => Number(row.id) === wsTradeId);

      if (idx === -1) return prev; // no matching row

      const row = prev[idx];

      const updatedTrades = row.trades?.length
        ? [
            {
              ...row.trades[0],
              last_trading_price:
                pnlUpdate.ltp ?? row.trades[0].last_trading_price,
            },
            ...row.trades.slice(1),
          ]
        : row.trades;

      const updatedRow = {
        ...row,
        trades: updatedTrades,
        profit_amount: pnlUpdate.profit_amount ?? row.profit_amount,
        profit_percent: pnlUpdate.profit_percent ?? row.profit_percent,
      };

      const next = [...prev];
      next[idx] = updatedRow;
      return next;
    });
  }, []);

  useEffect(() => {
    if (!autoRefresh) return;
    const interval = setInterval(() => {
      fetchFutureOptionTrade();
    }, 30000);
    return () => clearInterval(interval);
  }, [autoRefresh]);

  const trade = formData.trades[0];
  const entryValue = getEntryValue(trade);

  const { expected, profitPercent } = calculateExpectedProfit({
    entry: entryValue,
    target: formData.target_amount,
    lot: formData.lot_size,
    orderType: trade.order_type,
  });

  // useEffect(() => {
  //   setExtraFields((prev) =>
  //     prev.map((field) => {
  //       const target = parseFloat(formData.target_amount || 0);
  //       const lot = parseInt(field.lot_size || 0, 10);

  //       const t = field.trades[0] || {};
  //       const orderType = t.order_type || "BUY";

  //       let entry = 0;
  //       if (t.entry_price_type === "FLAT") {
  //         entry = parseFloat(t.entry_price || 0);
  //       } else if (t.entry_price_type === "RANGE") {
  //         entry = parseFloat(t.entry_price_to || 0);
  //       }

  //       const expected =
  //         !isNaN(target) &&
  //         target > 0 &&
  //         !isNaN(entry) &&
  //         entry > 0 &&
  //         !isNaN(lot) &&
  //         lot > 0
  //           ? orderType === "BUY"
  //             ? ((target - entry) * lot).toFixed(2)
  //             : ((entry - target) * lot).toFixed(2)
  //           : "";

  //       if (String(t.expected_profit) === String(expected)) return field;

  //       return {
  //         ...field,
  //         trades: [
  //           {
  //             ...t,
  //             expected_profit: expected,
  //           },
  //         ],
  //       };
  //     })
  //   );
  // }, [
  //   formData.target_amount,
  //   JSON.stringify(
  //     extraFields.map((f) => ({
  //       lot_size: f.lot_size,
  //       entry_price: f.trades[0]?.entry_price,
  //       entry_price_to: f.trades[0]?.entry_price_to,
  //       entry_price_type: f.trades[0]?.entry_price_type,
  //       order_type: f.trades[0]?.order_type,
  //     }))
  //   ),
  // ]);

  const validateFormSimple = (f) => {
    const error = (msg) => {
      toast.error(msg);
      return false;
    };
    const t = f.trades?.[0] || {};
    const isOption = f.instrument_type === 2;

    // top-level (stop_loss optional)

    if (![1, 2].includes(f.instrument_type))
      return error("Instrument Type required.");
    if (!f.symbol_id) return error("Symbol required.");
    if (!String(f.duration || "").trim()) return error("Duration required.");
    if (!(+f.lot_size > 0)) return error("Lot Size required.");
    if (isOption && !String(f.expire_date || "").trim())
      return error("Expiry Date required (Options).");

    // trade-level
    if (!["BUY", "SELL"].includes(t.order_type))
      return error("Order Type required.");
    if (!["FLAT", "RANGE"].includes(t.entry_price_type))
      return error("Entry Type required.");

    if (t.entry_price_type === "FLAT") {
      if (!(+t.entry_price > 0)) return error("Entry Price (>0) required.");
    } else {
      if (!(+t.entry_price_from > 0))
        return error("From Entry Price (>0) required.");
      if (!(+t.entry_price_to > 0))
        return error("To Entry Price (>0) required.");
      if (+t.entry_price_from > +t.entry_price_to)
        return error("From Price cannot be greater than To Price.");
    }

    if (isOption) {
      if (!["CE", "PE"].includes(t.option_type))
        return error("Option Type required.");
      if (!String(t.strike_price || "").trim())
        return error("Strike Price required.");
    }
    return true;
  };

  const validateAll = (formData, extraFields) => {
    if (!validateFormSimple(formData)) return false;
    for (const ex of extraFields) {
      if (!validateFormSimple(ex)) return false;
    }
    return true;
  };

  const updateTrade = (
    field,
    value,
    index = 0,
    isExtra = false,
    extraIndex = 0,
  ) => {
    if (
      [
        "script_name",
        "stop_loss",
        "stop_loss_percent",
        "target_amount",
        "duration",
        "lot_size",
        "expire_date",
        "instrument_type",
        "symbol_id",
        "symbol_name",
      ].includes(field)
    ) {
      setFormData((prev) => ({ ...prev, [field]: value }));
      return;
    }

    if (isExtra) {
      const newExtra = [...extraFields];
      newExtra[extraIndex].trades[index][field] = value;
      setExtraFields(newExtra);
    } else {
      setFormData((prev) => ({
        ...prev,
        trades: prev.trades.map((t, i) =>
          i === index ? { ...t, [field]: value } : t,
        ),
      }));
    }
  };

  const resetTradeDeps = () => {
    setExpiryDates([]);
    setStrikePrices([]);
    setStrikeMap({});
    updateTrade("expire_date", "");
    updateTrade("strike_price", "");
    updateTrade("last_trading_price", "");
    updateTrade("entry_price", "");
    updateTrade("entry_price_from", "");
    updateTrade("entry_price_to", "");
    updateTrade("price_selection_type", "BID");
  };

  const syncSelectedLTP = (optType, strike) => {
    if (!optType || !strike) return;
    const key = Number(strike);
    const ce = strikeMap?.[key]?.CE ?? null;
    const pe = strikeMap?.[key]?.PE ?? null;
    const selectedLtp = optType === "CE" ? ce : optType === "PE" ? pe : null;

    updateTrade(
      "last_trading_price",
      selectedLtp === null || selectedLtp === undefined
        ? ""
        : String(selectedLtp),
    );
  };

  const refreshLatestLTP = async (
    symbolName,
    expiry,
    optionType,
    strikePrice,
  ) => {
    try {
      const res = await axiosConfig({
        method: "post",
        url: "/stike-price-data/",
        data: {
          symbol: symbolName,
          expirytime: expiry,
        },
      });

      const rows = res?.data?.response?.strike_Data || [];

      for (const row of rows) {
        const ceStrike = row?.CE?.striker_price;
        const peStrike = row?.PE?.striker_price;

        if (optionType === "CE" && Number(ceStrike) === Number(strikePrice)) {
          return row.CE.ltp ?? null;
        }
        if (optionType === "PE" && Number(peStrike) === Number(strikePrice)) {
          return row.PE.ltp ?? null;
        }
      }

      return null;
    } catch (err) {
      console.error("Error refreshing LTP:", err);
      return null;
    }
  };

  // selected option auto refresh cmp
  const fetchAndSetSelectedCmp = useCallback(async () => {
    if (
      formData.instrument_type !== 2 ||
      !formData.symbol_name ||
      !formData.expire_date ||
      !formData.trades?.[0]?.option_type ||
      !formData.trades?.[0]?.strike_price
    )
      return;

    try {
      setCmpRefreshing(true);
      const ltp = await refreshLatestLTP(
        formData.symbol_name,
        formData.expire_date,
        formData.trades[0].option_type,
        formData.trades[0].strike_price,
        formData.trades[0].entry_price,
        formData.trades[0].price_selection_type,
      );

      if (ltp !== null && ltp !== undefined) {
        // update CMP
        setFormData((prev) => ({
          ...prev,
          trades: prev.trades.map((t, i) =>
            i === 0 ? { ...t, last_trading_price: String(ltp) } : t,
          ),
        }));
      }
    } catch (e) {
      console.error("CMP refresh error:", e);
    } finally {
      setCmpRefreshing(false);
    }
  }, [formData.symbol_name, formData.expire_date, formData.trades]);

  useEffect(() => {
    if (!openDialog) return;
    fetchAndSetSelectedCmp();
  }, [
    openDialog,
    // formData.symbol_name,
    // formData.expire_date,
    // formData.trades?.[0]?.option_type,
    // formData.trades?.[0]?.strike_price,
    // fetchAndSetSelectedCmp,
  ]);

  const fetchSymbols = async () => {
    setLoadingSymbols(true);
    try {
      const res = await axiosConfig({
        method: "get",
        url: "/option-trade-symbol-list/",
        data: {},
      });

      setSymbols(res?.data?.response || []);
    } catch (err) {
      console.log("Error fetching symbols:", err);
      toast.error(
        err?.response?.data?.response ||
          err?.message ||
          "Failed to fetch symbols",
      );
    } finally {
      setLoadingSymbols(false);
    }
  };
  const fetchExpiryDates = async (symbolName) => {
    if (!symbolName) return;

    try {
      setExpiryLoading(true);

      const res = await axiosConfig({
        method: "post",
        url: "/optionchain/expirydate",
        data: {
          symbol: symbolName,
        },
      });

      const dates = res?.data?.response || [];
      setExpiryDates(dates);

      const first = dates[0] || "";
      if (first) {
        setFormData((p) => ({ ...p, expire_date: first }));
        await fetchStrikePrices(symbolName, first);
      } else {
        setFormData((p) => ({ ...p, expire_date: "" }));
      }
    } catch (err) {
      console.log("Error fetching expiry dates:", err);
      toast.error("Failed to fetch expiry dates");
      setExpiryDates([]);
      updateTrade("expire_date", "");
    } finally {
      setExpiryLoading(false);
    }
  };

  const fetchStrikePrices = async (symbolName, expiry) => {
    if (!symbolName || !expiry) return;

    try {
      setStrikeLoading(true);

      const res = await axiosConfig({
        method: "post",
        url: "/stike-price-data/",
        data: {
          symbol: symbolName,
          expirytime: expiry,
        },
      });

      const rows = res?.data?.response?.strike_Data || [];
      const ceStrikes = [];
      const peStrikes = [];
      const map = {};

      for (const row of rows) {
        if (row?.CE?.striker_price != null) {
          ceStrikes.push(String(row.CE.striker_price));
          map[row.CE.striker_price] = {
            ...(map[row.CE.striker_price] || {}),
            CE: row.CE.ltp ?? null,
          };
        }
        if (row?.PE?.striker_price != null) {
          peStrikes.push(String(row.PE.striker_price));
          map[row.PE.striker_price] = {
            ...(map[row.PE.striker_price] || {}),
            PE: row.PE.ltp ?? null,
          };
        }
      }

      setStrikeMap(map);
      setStrikePricesMap({
        CE: ceStrikes.sort((a, b) => a - b),
        PE: peStrikes.sort((a, b) => a - b),
      });

      // Sync LTP only if option_type and strike_price are set in latest state
      setFormData((prev) => {
        const { option_type, strike_price } = prev.trades[0] || {};
        if (option_type && strike_price) {
          const key = Number(strike_price);
          const ltp = option_type === "CE" ? map[key]?.CE : map[key]?.PE;
          return {
            ...prev,
            trades: prev.trades.map((t, i) =>
              i === 0
                ? { ...t, last_trading_price: ltp != null ? String(ltp) : "" }
                : t,
            ),
          };
        }
        return prev;
      });
    } catch (err) {
      console.log("Error fetching strike prices:", err);
      toast.error("Failed to fetch strike prices");
      setStrikePricesMap({ CE: [], PE: [] });
      setStrikeMap({});
    } finally {
      setStrikeLoading(false);
    }
  };

  useEffect(() => {
    fetchSymbols();
    fetchFutureOptionTrade();
  }, [page, tradeFilter]);

  // Auto-select NIFTY once symbols load (only if no symbol chosen yet)
  useEffect(() => {
    if (!symbols.length || formData.symbol_id) return;
    const nifty = symbols.find((s) => s.name?.toUpperCase() === "NIFTY");
    if (!nifty) return;
    setFormData((p) => ({
      ...p,
      symbol_id: nifty.symbol_id,
      symbol_name: nifty.name,
      lot_size: nifty.lot_size || p.lot_size,
    }));
    setSelectedSymbolName(nifty.name);
    fetchExpiryDates(nifty.name);
  }, [symbols]); // eslint-disable-line

  const handleSubmit = async () => {
    if (!validateAll(formData, extraFields)) return;

    setLoadingPreview(true);

    try {
      let latestMainLTP = null;
      if (formData.instrument_type === 2) {
        latestMainLTP = await refreshLatestLTP(
          formData.symbol_name,
          formData.expire_date,
          formData.trades[0].option_type,
          formData.trades[0].strike_price,
        );

        if (latestMainLTP !== null) {
          setFormData((prev) => ({
            ...prev,
            trades: prev.trades.map((t, idx) =>
              idx === 0
                ? { ...t, last_trading_price: String(latestMainLTP) }
                : t,
            ),
          }));
        }
      }

      if (extraFields.length > 0) {
        const updatedExtraFields = [];

        for (let i = 0; i < extraFields.length; i++) {
          const field = extraFields[i];

          if (field.instrument_type === 2) {
            const ltp = await refreshLatestLTP(
              field.symbol_name,
              field.expire_date,
              field.trades[0].option_type,
              field.trades[0].strike_price,
            );

            if (ltp !== null) {
              updatedExtraFields.push({
                ...field,
                trades: field.trades.map((t, idx) =>
                  idx === 0 ? { ...t, last_trading_price: String(ltp) } : t,
                ),
              });
            } else {
              updatedExtraFields.push(field);
            }
          } else {
            updatedExtraFields.push(field);
          }
        }

        setExtraFields(updatedExtraFields);
      }

      // ✅ Now apply optimal entry price logic
      if (latestMainLTP !== null) {
        setFormData((prev) => ({
          ...prev,
          trades: prev.trades.map((t, idx) => {
            if (idx !== 0) return t;

            return {
              ...t,
            };
          }),
        }));
      }

      // ✅ Open preview dialog
      setOpenPreview(true);
    } catch (err) {
      console.error("Preview Error:", err);
      toast.error("Failed to fetch latest data");
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleFinalConfirm = async () => {
    if (!validateAll(formData, extraFields)) return;
    setLoadingSubmit(true);

    try {
      const formattedSymbolName = formatSymbolName(
        formData.symbol_name,
        formData.expire_date,
        formData.trades[0].strike_price,
        formData.trades[0].option_type,
      );

      const calculatedMain = formData.trades.map((t) => {
        const entry = getEntryValue(t);
        return calculateExpectedProfit({
          entry,
          target: formData.target_amount,
          lot: formData.lot_size,
          orderType: t.order_type,
        });
      });
      const mainTrade = formData.trades.map((t, i) => ({
        strike_price: t.strike_price ? Number(t.strike_price) : null,
        order_type: t.order_type || "",
        option_type: t.option_type || "",
        last_trading_price: t.last_trading_price || "",
        price_selection_type: t.price_selection_type || "CMP",
        bid_type:
          t.price_selection_type === "BID" ? t.bid_type || "UPPER" : null,
        entry_price_type: t.entry_price_type,
        entry_price:
          t.entry_price_type === "FLAT" ? Number(t.entry_price) || null : null,
        entry_price_from:
          t.entry_price_type === "RANGE"
            ? Number(t.entry_price_from) || null
            : null,
        entry_price_to:
          t.entry_price_type === "RANGE"
            ? Number(t.entry_price_to) || null
            : null,
        expected_profit: calculatedMain[i].expected,
        expected_potential: t.profit_percent || null,
        valid_for_parrva: !!t.valid_for_parrva,
      }));

      const extraTrades = extraFields
        .map((f) =>
          f.trades.map((t) => ({
            strike_price: t.strike_price ? Number(t.strike_price) : null,
            order_type: t.order_type || "",
            option_type: t.option_type || "",
            last_trading_price: t.last_trading_price || "",
            entry_price_type: t.entry_price_type,
            entry_price:
              t.entry_price_type === "FLAT"
                ? Number(t.entry_price) || null
                : null,
            entry_price_from:
              t.entry_price_type === "RANGE"
                ? Number(t.entry_price_from) || null
                : null,
            entry_price_to:
              t.entry_price_type === "RANGE"
                ? Number(t.entry_price_to) || null
                : null,
            expected_profit: expected,
            expected_potential: t.profit_percent || null,
            valid_for_parrva: !!t.valid_for_parrva,
          })),
        )
        .flat();

      const payload = {
        script_name: formData.script_name || "",
        instrument_type: formData.instrument_type || 1,
        symbol_id: formData.symbol_id || null,
        duration: formData.duration || "",
        lot_size: formData.lot_size || "",
        expire_date: formData.expire_date || "",
        stop_loss: formData.stop_loss || "",
        target_amount: formData.target_amount || "",
        trade_symbol: formattedSymbolName || "",
        trades: [...mainTrade, ...extraTrades],
      };

      console.log(payload, "payload");

      const res = await axiosConfig({
        method: "post",
        url: "/option-future-trade/",
        data: payload,
      });

      toast.success("Trade submitted successfully!");
      setOpenPreview(false);
      setOpenDialog(false);
      fetchFutureOptionTrade();
      setFormData(initialFormData);
      setExtraFields([]);
    } catch (err) {
      toast.error(err?.response?.data?.response || "Failed to submit trade!");
    } finally {
      setLoadingSubmit(false);
    }
  };
  console.log(formData, "formData");
  const fetchFutureOptionTrade = async () => {
    setFutureOptionLoading(true);

    try {
      const params = {
        page: page,
        trade_type: tradeFilter !== "all" ? tradeFilter : undefined,
      };

      const response = await axiosConfig({
        method: "get",
        url: "/option-trade-admin-list/",
        params,
      });

      const tradeData = response?.data || {};

      setTotalCount(tradeData.count || 0);
      setFutureOptionData(tradeData.results || []);
    } catch (error) {
      toast.error(
        error?.response?.data?.detail ||
          error?.message ||
          "Failed to fetch trades",
      );
    } finally {
      setFutureOptionLoading(false);
    }
  };

  const handleAddMore = () => {
    setExtraFields((prev) => [...prev, { ...formData }]);

    setFormData((prev) => {
      const clonedTrades = prev.trades.map((t) => ({ ...t }));

      return {
        ...prev,
        trades: [...clonedTrades],
      };
    });

    toast.success("Full form copied and added");
  };
  const entry = getEntryValue(formData.trades[0]);
  const slPercent = stopLossToPercent(
    entry,
    formData.stop_loss,
    formData.trades[0].entry_price_type,
  );
  const sl = percentToStopLoss(
    entry,
    slPercent,
    formData.trades[0].entry_price_type,
  );
  const profit = targetToProfitPercent(
    entry,
    formData.target_amount,
    formData.trades[0].entry_price_type,
  );
  const target = percentToTarget(
    entry,
    profit,
    formData.trades[0].entry_price_type,
  );

  const downloadCSV = async () => {
    try {
      toast.loading("Preparing CSV...", { id: "csv" });

      // STEP 1: Fetch ALL pages for selected filter
      let page = 1;
      let allData = [];
      let hasNext = true;

      while (hasNext) {
        const params = {
          page,
          trade_type: tradeFilter !== "all" ? tradeFilter : undefined,
        };

        const response = await axiosConfig({
          method: "get",
          url: "/option-trade-admin-list/",
          params,
        });

        const data = response?.data;

        allData = [...allData, ...(data.results || [])];

        if (data.next) {
          page += 1;
        } else {
          hasNext = false;
        }
      }

      // STEP 2: Check empty data
      if (!allData || allData.length === 0) {
        toast.dismiss("csv");
        toast.error("No data available!");
        return;
      }

      // STEP 3: CSV generation (your existing logic)
      const headers = Object.keys(allData[0]);
      const csvRows = [];

      const displayHeaders = headers.flatMap((h) =>
        h === "trades" ? ["entry_price", "bid_type", "price_selection_type"] : [h]
      );
      csvRows.push(displayHeaders.join(","));

      const csvCell = (val) => {
        if (val === null || val === undefined) val = "";
        else if (typeof val === "object") val = JSON.stringify(val);
        return `"${String(val).replace(/"/g, '""')}"`;
      };

      allData.forEach((row) => {
        const values = headers.flatMap((h) => {
          const val = row[h];
          if (h === "trades" && Array.isArray(val)) {
            return [
              csvCell(val.map((t) => t.entry_price ?? "").join(" | ")),
              csvCell(val.map((t) => t.bid_type ?? "").join(" | ")),
              csvCell(val.map((t) => t.price_selection_type ?? "").join(" | ")),
            ];
          }
          return [csvCell(val)];
        });
        csvRows.push(values.join(","));
      });

      const csvString = csvRows.join("\n");
      const blob = new Blob([csvString], { type: "text/csv" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);

      const filename =
        tradeFilter === "all" ? "trades-all.csv" : `trades-${tradeFilter}.csv`;

      link.download = filename;
      link.click();

      toast.dismiss("csv");
      toast.success("CSV downloaded successfully!");
    } catch (error) {
      toast.dismiss("csv");
      toast.error("Failed to download CSV");
    }
  };

  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      <PnlWebSocketListener enabled={true} onPnlUpdate={handleWsPnlUpdate} />
      {/* {!lastPnl && (
        <Typography variant="body2">
          Web socket data not loaded yet...
        </Typography>
      )} */}

      {/* Admin Header Bar */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          p: 2.5,
          mb: 2.5,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 4px 20px rgba(0,0,0,0.18)",
        }}
      >
        <Box>
          <Typography
            variant="h5"
            fontWeight="700"
            sx={{ color: "#ffffff", letterSpacing: 0.5 }}
          >
            Options Dashboard
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: "rgba(255,255,255,0.6)",
              letterSpacing: 1,
              textTransform: "uppercase",
            }}
          >
            Options Trade Management
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              background: "rgba(255,255,255,0.08)",
              borderRadius: "8px",
              px: 1.5,
              py: 0.5,
              border: "1px solid rgba(255,255,255,0.15)",
            }}
          >
            <Switch
              checked={autoRefresh}
              onChange={(e) => setAutoRefresh(e.target.checked)}
              color="success"
              size="small"
            />
            <Typography
              sx={{
                fontWeight: "600",
                color: autoRefresh ? "#4ade80" : "rgba(255,255,255,0.6)",
                fontSize: "13px",
              }}
            >
              Auto Refresh: {autoRefresh ? "ON" : "OFF"}
            </Typography>
          </Box>

          <Button
            variant="contained"
            onClick={() => setOpenDialog(true)}
            sx={{
              fontWeight: "700",
              px: 2.5,
              py: 1,
              borderRadius: "8px",
              textTransform: "uppercase",
              letterSpacing: 0.5,
              fontSize: "13px",
              background: "#016551",
              boxShadow: "0 2px 8px #016551",
              "&:hover": {
                background: "linear-gradient(135deg, #016551, #04343a)",
              },
            }}
          >
            + Add Options Trades
          </Button>
        </Box>
      </Box>

      <BannedSharesMarquee shares={symbols} />
      {/* Filter Toolbar */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#ffffff",
          borderRadius: "10px",
          p: "10px 16px",
          mb: 2,
          boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
          border: "1px solid #e2e8f0",
        }}
      >
        <Box sx={{ display: "flex", gap: 1 }}>
          {[
            { label: "OPEN", value: "open" },
            { label: "INACTIVE", value: "inactive" },
            { label: "CLOSE", value: "close" },
            { label: "CANCEL", value: "cancel" },
            { label: "ALL", value: "all" },
          ].map(({ label, value }) => (
            <Button
              key={value}
              onClick={() => { setTradeFilter(value); localStorage.setItem("option_tradeFilter", value); }}
              sx={{
                fontWeight: "700",
                fontSize: "11px",
                py: 0.5,
                px: 2,
                borderRadius: "6px",
                letterSpacing: 0.8,
                transition: "all 0.2s",
                ...(tradeFilter === value
                  ? {
                      background: "#016551",
                      color: "#ffffff",
                      boxShadow: "0 2px 8px #04343a",
                      "&:hover": { background: "#04343a" },
                    }
                  : {
                      color: "#64748b",
                      background: "#f1f5f9",
                      "&:hover": { background: "#e2e8f0", color: "#016551" },
                    }),
              }}
            >
              {label}
            </Button>
          ))}
        </Box>
        <Button
          variant="contained"
          onClick={downloadCSV}
          sx={{
            fontWeight: "700",
            fontSize: "12px",
            py: 0.6,
            px: 2,
            borderRadius: "7px",
            background: "#016551",
            letterSpacing: 0.5,
            boxShadow: "0 2px 8px #016551",
            "&:hover": {
              background: "linear-gradient(135deg, #016551, #04343a)",
            },
          }}
        >
          Download Excel
        </Button>
      </Box>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 3,
            py: 2,
            background: "#04343a",
          }}
        >
          <Typography
            variant="h6"
            fontWeight="700"
            sx={{ color: "#ffffff", letterSpacing: 0.3 }}
          >
            Add Options Trade
          </Typography>
          <IconButton
            onClick={() => setOpenDialog(false)}
            size="small"
            sx={{
              color: "rgba(255,255,255,0.7)",
              "&:hover": { color: "#fff", background: "rgba(255,255,255,0.1)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent>
          <Grid container spacing={2}>
            {/* screen name */}
            <Grid item xs={12} md={3}>
              <Autocomplete
                freeSolo
                options={["Hero Zero (High Risk)", "High Risk"]}
                value={formData.script_name || ""}
                onChange={(_e, newValue) => {
                  updateTrade("script_name", newValue || "");
                }}
                onInputChange={(_e, newInputValue) => {
                  updateTrade("script_name", newInputValue);
                }}
                getOptionLabel={(option) => option}
                renderOption={(props, option) => <li {...props}>{option}</li>}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      !["Hero Zero (High Risk)", "High Risk"].includes(
                        formData.script_name,
                      ) && formData.script_name
                        ? "Adding Custom Script Name" // Visual cue
                        : "Script Name"
                    }
                    placeholder="Select or type custom"
                    fullWidth
                    required
                  />
                )}
              />
              {/* Custom typing hint */}
              {formData.script_name &&
                !["Hero Zero (High Risk)", "High Risk"].includes(
                  formData.script_name,
                ) && (
                  <Typography variant="caption" color="primary">
                    Y're typing a custom script name
                  </Typography>
                )}
            </Grid>

            {/* Instrument type */}
            <Grid item xs={12} md={3}>
              <TextField
                select
                label="Instrument Type"
                required
                fullWidth
                value={formData.instrument_type || ""}
                onChange={(e) => {
                  const id = parseInt(e.target.value, 10);
                  setFormData((p) => ({ ...p, instrument_type: id }));
                  if (id !== 2) {
                    updateTrade("option_type", "");
                    updateTrade("expire_date", "");
                    updateTrade("strike_price", "");
                    updateTrade("last_trading_price", "");
                    setExpiryDates([]);
                    setStrikePrices([]);
                    setStrikeMap({});
                  }
                }}
              >
                <MenuItem value={1}>FUTURE</MenuItem>
                <MenuItem value={2}>OPTION</MenuItem>
              </TextField>
            </Grid>
            {/* Symbol */}
            <Grid item xs={12} md={3}>
              <Autocomplete
                required
                options={symbols || []}
                getOptionLabel={(o) => o?.name || ""}
                loading={loadingSymbols}
                value={
                  formData.symbol_id
                    ? symbols.find((s) => s.symbol_id === formData.symbol_id) ||
                      null
                    : null
                }
                onChange={async (_e, newValue) => {
                  if (newValue?.is_banned) {
                    toast.error(`${newValue.name} is banned! 🚫`);
                    return;
                  }
                  const symbolId = newValue ? newValue.symbol_id : null;
                  const symbolName = newValue ? newValue.name : "";
                  const lotSize = newValue ? newValue.lot_size : "";
                  setFormData((p) => ({
                    ...p,
                    symbol_id: symbolId,
                    symbol_name: symbolName,
                    lot_size: lotSize,
                  }));
                  setSelectedSymbolName(symbolName);

                  resetTradeDeps();

                  if (symbolName) {
                    await fetchExpiryDates(symbolName);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Symbol"
                    fullWidth
                    required
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingSymbols ? (
                            <CircularProgress size={18} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            {/* options type */}
            <Grid item xs={12} md={3}>
              <TextField
                required
                select
                label="Option Type"
                fullWidth
                value={formData.trades[0].option_type || ""}
                onChange={(e) => {
                  const opt = e.target.value;
                  updateTrade("option_type", opt);

                  const strikes = strikePricesMap[opt] || [];
                  if (!strikes.includes(formData.trades[0].strike_price)) {
                    updateTrade("strike_price", "");
                  }

                  syncSelectedLTP(opt, formData.trades[0].strike_price);
                  // fetchAndSetSelectedCmp();
                }}
                disabled={!isOption}
              >
                <MenuItem value="CE">CE</MenuItem>
                <MenuItem value="PE">PE</MenuItem>
              </TextField>
            </Grid>
            {/* expiry date */}
            <Grid item xs={12} md={3}>
              <TextField
                required
                select
                label="Expiry Date"
                fullWidth
                value={formData.expire_date || ""}
                onChange={async (e) => {
                  const value = e.target.value;
                  updateTrade("expire_date", value);

                  setStrikePrices([]);
                  setStrikeMap({});
                  updateTrade("strike_price", "");
                  updateTrade("last_trading_price", "");

                  if (selectedSymbolName && value) {
                    await fetchStrikePrices(selectedSymbolName, value);
                    // fetchAndSetSelectedCmp();
                  }
                }}
                SelectProps={{ displayEmpty: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {expiryLoading ? <CircularProgress size={18} /> : null}
                    </InputAdornment>
                  ),
                }}
                placeholder="Select expiry"
              >
                {expiryDates.length === 0 && (
                  <MenuItem value="" disabled>
                    {expiryLoading ? "Loading…" : ""}
                  </MenuItem>
                )}
                {expiryDates.map((ed) => (
                  <MenuItem key={ed} value={ed}>
                    {ed}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            {/* strike price */}
            <Grid item xs={12} md={3}>
              <Autocomplete
                required
                options={
                  formData.trades[0].option_type
                    ? strikePricesMap[formData.trades[0].option_type] || []
                    : []
                }
                value={formData.trades[0].strike_price || ""}
                onChange={(e, newValue) => {
                  updateTrade("strike_price", newValue);
                  syncSelectedLTP(formData.trades[0].option_type, newValue);
                  // Reset entry price and set price type to BID
                  updateTrade("entry_price", "");
                  updateTrade("entry_price_from", "");
                  updateTrade("entry_price_to", "");
                  updateTrade("price_selection_type", "BID");
                }}
                disabled={
                  !formData.expire_date || !formData.trades[0].option_type
                }
                loading={strikeLoading}
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    label="Strike Price"
                    placeholder="Select strike"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {strikeLoading ? (
                            <CircularProgress size={18} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            {/* Order Type */}
            <Grid item xs={12} md={3}>
              <TextField
                required
                select
                label="Order Type"
                fullWidth
                value={formData.trades[0].order_type}
                onChange={(e) => updateTrade("order_type", e.target.value)}
              >
                <MenuItem value="BUY">BUY</MenuItem>
                <MenuItem value="SELL">SELL</MenuItem>
              </TextField>
            </Grid>
            {/* lots size */}
            <Grid item xs={12} md={3}>
              <TextField
                required
                label="Lot Size"
                type="number"
                fullWidth
                value={formData.lot_size || ""}
                InputProps={{ readOnly: true }}
              />
            </Grid>
            {/* duration */}
            <Grid item xs={12} md={3}>
              <TextField
                required
                label="Duration"
                fullWidth
                value={formData.duration}
                onChange={(e) =>
                  setFormData((p) => ({ ...p, duration: e.target.value }))
                }
              />
            </Grid>
            {/* entry price */}
            <Grid item xs={12} md={3}>
              <TextField
                required
                select
                label="Entry Type"
                fullWidth
                value={formData.trades[0].entry_price_type}
                onChange={(e) =>
                  updateTrade("entry_price_type", e.target.value)
                }
              >
                <MenuItem value="FLAT">Flat</MenuItem>
                <MenuItem value="RANGE">Range</MenuItem>
              </TextField>
            </Grid>
            {formData.trades[0].entry_price_type === "FLAT" && (
              <Grid item xs={12} md={3}>
                <TextField
                  label="Entry Price"
                  type="number"
                  fullWidth
                  value={formData.trades[0].entry_price}
                  onChange={(e) => updateTrade("entry_price", e.target.value)}
                  InputLabelProps={{
                    shrink: Boolean(formData.trades[0].entry_price),
                  }}
                />
              </Grid>
            )}
            {formData.trades[0].entry_price_type === "RANGE" && (
              <>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="From Entry Price"
                    type="number"
                    fullWidth
                    value={formData.trades[0].entry_price_from}
                    onChange={(e) =>
                      updateTrade("entry_price_from", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="To Entry Price"
                    type="number"
                    fullWidth
                    value={formData.trades[0].entry_price_to}
                    onChange={(e) =>
                      updateTrade("entry_price_to", e.target.value)
                    }
                  />
                </Grid>
              </>
            )}
            {/* expected profit */}
            <Grid item xs={12} md={3}>
              <TextField
                label="Expected Profit"
                fullWidth
                value={expected || ""}
                InputProps={{
                  readOnly: true,
                  style: { background: "#e6ffed" },
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Stop Loss %"
                fullWidth
                value={
                  formData.stop_loss_percent !== "" &&
                  formData.stop_loss_percent != null
                    ? `${formData.stop_loss_percent}%`
                    : ""
                }
                onChange={(e) => {
                  const percent = e.target.value.replace(/[^0-9.]/g, "");
                  const entry = getEntryValue(formData.trades[0]);
                  const orderType = formData.trades[0]?.order_type;
                  const sl = percentToStopLoss(entry, percent, orderType);
                  updateTrade("stop_loss_percent", percent);
                  updateTrade("stop_loss", sl);
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="CMP"
                fullWidth
                value={formData.trades[0]?.last_trading_price ?? ""}
                InputProps={{
                  readOnly: true,
                  style: { background: "#e6ffed" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={fetchAndSetSelectedCmp}
                        disabled={cmpRefreshing}
                        aria-label="Refresh LTP"
                      >
                        <RefreshIcon
                          fontSize="small"
                          style={{
                            transform: cmpRefreshing
                              ? "rotate(360deg)"
                              : "none",
                            transition: "transform 0.6s",
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            {/* ========== RADIO BUTTONS FOR BID/CMP ========== */}
            <Grid item xs={12} md={3}>
              <FormControl component="fieldset">
                <FormLabel
                  component="legend"
                  sx={{
                    fontSize: "0.875rem",
                    // mb: 0.5,
                    fontWeight: 500,
                  }}
                >
                  Price Type
                </FormLabel>
                <RadioGroup
                  row
                  value={formData.trades[0].price_selection_type}
                  onChange={(e) => {
                    const selectedType = e.target.value;
                    updateTrade("price_selection_type", selectedType);

                    if (selectedType === "MARKETPRICE") {
                      const ltp = formData.trades[0]?.last_trading_price;

                      if (ltp) {
                        updateTrade("entry_price_type", "FLAT");
                        updateTrade("entry_price", ltp);
                        updateTrade("entry_price_from", "");
                        updateTrade("entry_price_to", "");
                      }
                    }
                    if (selectedType === "BID") {
                      updateTrade("entry_price", "");
                      updateTrade("entry_price_from", "");
                      updateTrade("entry_price_to", "");
                      updateTrade("bid_type", "UPPER");
                    }
                    if (selectedType === "MARKETPRICE") {
                      updateTrade("bid_type", null);
                    }
                  }}
                  sx={{
                    // gap: 1,
                    flexWrap: "nowrap",
                  }}
                >
                  <FormControlLabel
                    value="BID"
                    control={<Radio />}
                    label="Bid"
                    sx={{ mr: "6px" }}
                  />
                  <FormControlLabel
                    value="MARKETPRICE"
                    control={<Radio />}
                    label="MARKETPRICE"
                    sx={{ mr: "6px" }}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            {formData.trades[0].price_selection_type === "BID" && (
              <Grid item xs={12} md={3}>
                <TextField
                  select
                  label="Bid Type"
                  fullWidth
                  value={formData.trades[0].bid_type || "UPPER"}
                  onChange={(e) => updateTrade("bid_type", e.target.value)}
                >
                  <MenuItem value="UPPER">Upper</MenuItem>
                  <MenuItem value="DOWN">Down</MenuItem>
                </TextField>
              </Grid>
            )}

            <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!formData.trades[0].valid_for_parrva}
                    onChange={(e) => updateTrade("valid_for_parrva", e.target.checked)}
                    color="success"
                  />
                }
                label="Valid for Parrva"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={0.5}>
            {/* stop loss */}
            <Grid item xs={12} md={4}>
              <TextField
                label="Stop Loss"
                fullWidth
                value={formData.stop_loss || ""}
                onChange={(e) => {
                  const sl = e.target.value.replace(/[^0-9.]/g, "");
                  const entry = getEntryValue(formData.trades[0]);
                  const orderType = formData.trades[0]?.order_type;
                  const slPercent = stopLossToPercent(entry, sl);
                  updateTrade("stop_loss", sl);
                  updateTrade("stop_loss_percent", slPercent);
                }}
              />
            </Grid>
            {/* target price */}
            <Grid item xs={12} md={4}>
              <TextField
                label="Target Price"
                fullWidth
                value={formData.target_amount || ""}
                onChange={(e) => {
                  const tgt = e.target.value.replace(/[^0-9.]/g, "");
                  const entry = getEntryValue(formData.trades[0]);
                  const orderType = formData.trades[0]?.order_type;
                  const pct = targetToProfitPercent(entry, tgt);
                  updateTrade("target_amount", tgt);
                  updateTrade("profit_percent", pct);
                }}
              />
            </Grid>
            {/* profit % */}
            <Grid item xs={12} md={4}>
              <TextField
                label="Profit %"
                fullWidth
                value={
                  formData?.trades[0]?.profit_percent !== "" &&
                  formData?.trades[0]?.profit_percent != null
                    ? `${formData?.trades[0]?.profit_percent}%`
                    : ""
                }
                onChange={(e) => {
                  const percent = e.target.value.replace(/[^0-9.]/g, "");
                  const entry = getEntryValue(formData.trades[0]);
                  const orderType = formData.trades[0]?.order_type;
                  const tgt = percentToTarget(entry, percent, orderType);
                  updateTrade("profit_percent", percent); // store: "10"
                  updateTrade("target_amount", tgt);
                }}
              />
            </Grid>
          </Grid>
          {extraFields.map((field, idx) => {
            return (
              <Box
                key={idx}
                sx={{
                  mt: 3,
                  p: 2,
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  background: "#fafafa",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Instrument Type"
                      fullWidth
                      value={field.instrument_type === 1 ? "FUTURE" : "OPTION"}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Symbol"
                      fullWidth
                      value={
                        symbols.find((s) => s.symbol_id === field.symbol_id)
                          ?.name || ""
                      }
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Expiry Date"
                      fullWidth
                      value={field.expire_date}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Lot Size"
                      fullWidth
                      value={field.lot_size}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      select
                      label="Strike Price"
                      fullWidth
                      value={field.trades[0].strike_price || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        setExtraFields((prev) => {
                          const copy = [...prev];
                          copy[idx].trades[0].strike_price = value;
                          return copy;
                        });
                      }}
                    >
                      {strikePrices.length === 0 && (
                        <MenuItem value="" disabled>
                          {strikeLoading ? "Loading…" : "No strikes"}
                        </MenuItem>
                      )}
                      {strikePrices.map((sp) => (
                        <MenuItem key={sp} value={sp}>
                          {sp}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      select
                      label="Order Type"
                      fullWidth
                      value={field.trades[0].order_type || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        setExtraFields((prev) => {
                          const copy = [...prev];
                          copy[idx].trades[0].order_type = value;
                          return copy;
                        });
                      }}
                    >
                      <MenuItem value="BUY">BUY</MenuItem>
                      <MenuItem value="SELL">SELL</MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      select
                      label="Option Type"
                      fullWidth
                      value={field.trades[0].option_type || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        setExtraFields((prev) => {
                          const copy = [...prev];
                          copy[idx].trades[0].option_type = value;

                          const strike = copy[idx].trades[0].strike_price;
                          if (strike) {
                            const key = Number(strike);
                            const ce = strikeMap?.[key]?.CE ?? null;
                            const pe = strikeMap?.[key]?.PE ?? null;
                            copy[idx].trades[0].last_trading_price =
                              value === "CE" ? ce : value === "PE" ? pe : "";
                          }

                          return copy;
                        });
                      }}
                      disabled={!isOption}
                    >
                      <MenuItem value="CE">CE</MenuItem>
                      <MenuItem value="PE">PE</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      select
                      label="entry_price_type"
                      fullWidth
                      value={field.trades[0].entry_price_type || "FLAT"}
                      onChange={(e) => {
                        const value = e.target.value;
                        setExtraFields((prev) => {
                          const copy = [...prev];
                          copy[idx].trades[0].entry_price_type = value;
                          return copy;
                        });
                      }}
                    >
                      <MenuItem value="FLAT">Flat</MenuItem>
                      <MenuItem value="RANGE">Range</MenuItem>
                    </TextField>
                  </Grid>

                  {/* Conditionally render based on priceType */}
                  {field.trades[0].entry_price_type === "FLAT" && (
                    <Grid item xs={12} md={3}>
                      <TextField
                        label="Entry Price"
                        type="number"
                        fullWidth
                        value={field.trades[0].entry_price || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          setExtraFields((prev) => {
                            const copy = [...prev];
                            copy[idx].trades[0].entry_price = value;
                            return copy;
                          });
                        }}
                      />
                    </Grid>
                  )}

                  {field.trades[0].entry_price_type === "RANGE" && (
                    <>
                      <Grid item xs={12} md={3}>
                        <TextField
                          label="From Price"
                          type="number"
                          fullWidth
                          value={field.trades[0].entry_price_from || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            setExtraFields((prev) => {
                              const copy = [...prev];
                              copy[idx].trades[0].entry_price_from = value;
                              return copy;
                            });
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <TextField
                          label="To Price"
                          type="number"
                          fullWidth
                          value={field.trades[0].entry_price_to || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            setExtraFields((prev) => {
                              const copy = [...prev];
                              copy[idx].trades[0].entry_price_to = value;
                              return copy;
                            });
                          }}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Expected Profit"
                      fullWidth
                      value={field.trades[0]?.expected_profit || 0}
                      InputProps={{
                        readOnly: true,
                        style: { background: "#e6ffed" },
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            );
          })}
        </DialogContent>

        <DialogActions
          sx={{ px: 3, py: 2, borderTop: "1px solid #e2e8f0", gap: 1 }}
        >
          <Button
            variant="outlined"
            onClick={() => {
              setFormData({
                instrument_type: "",
                symbol_id: null,
                duration: "",
                lot_size: "",
                expire_date: "",
                stop_loss: "",
                target_amount: "",
                trades: [
                  {
                    strike_price: "",
                    order_type: "",
                    option_type: "",
                    last_trading_price: "",
                    entry_price_type: "FLAT",
                    entry_price: "",
                    entry_price_from: "",
                    entry_price_to: "",
                    expected_profit: "",
                    profit_percent: "",
                    valid_for_parrva: false,
                  },
                ],
              });
              setExtraFields([]);
            }}
            sx={{
              borderRadius: "7px",
              fontWeight: 600,
              color: "#64748b",
              borderColor: "#cbd5e1",
              "&:hover": { borderColor: "#94a3b8", background: "#f8fafc" },
            }}
          >
            Reset
          </Button>

          <Button
            onClick={handleAddMore}
            disabled={loadingPreview || loadingSubmit}
            variant="outlined"
            sx={{
              borderRadius: "7px",
              fontWeight: 600,
              borderColor: "#16a34a",
              color: "#16a34a",
              "&:hover": { background: "#f0fdf4" },
            }}
          >
            Add More
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={loadingPreview || loadingSubmit}
            sx={{
              borderRadius: "7px",
              fontWeight: 700,
              background: "linear-gradient(135deg, #16a34a, #15803d)",
              px: 3,
              boxShadow: "0 2px 8px rgba(22,163,74,0.35)",
              "&:hover": {
                background: "linear-gradient(135deg, #15803d, #166534)",
              },
            }}
          >
            Review
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
          },
        }}
      >
        <Box
          sx={{
            px: 3,
            py: 2,
            background: "#04343a",
          }}
        >
          <Typography
            variant="h6"
            fontWeight="700"
            sx={{ color: "#ffffff", letterSpacing: 0.3 }}
          >
            Preview Data
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "rgba(255,255,255,0.55)" }}
          >
            Review before submitting
          </Typography>
        </Box>
        <DialogContent
          sx={{
            overflowY: "auto",
            pt: 2,
          }}
        >
          {[...formData.trades, ...extraFields.flatMap((f) => f.trades)].map(
            (trade, idx) => (
              <TableContainer
                key={idx}
                component={Paper}
                sx={{
                  mb: 2,
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                }}
              >
                <Table stickyHeader>
                  <TableBody>
                    {/* <TableRow>
                      <TableCell>Entry Date</TableCell>
                      <TableCell>
                        {new Date().toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "2-digit",
                        })}
                      </TableCell>
                    </TableRow> */}
                    <TableRow>
                      <TableCell>Screen Name</TableCell>
                      <TableCell>{formData.script_name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Instrument</TableCell>
                      <TableCell>
                        {formData.instrument_type === 1 ? "FUTURE" : "OPTION"}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Symbol</TableCell>
                      <TableCell>
                        {symbols.find((s) => s.symbol_id === formData.symbol_id)
                          ?.name || ""}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Strike Price</TableCell>
                      <TableCell>{trade.strike_price}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Expiry Date</TableCell>
                      <TableCell>{formData.expire_date}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Lots Size</TableCell>
                      <TableCell>{formData.lot_size}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Order Type</TableCell>
                      <TableCell>{trade.order_type}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Option Type</TableCell>
                      <TableCell>{trade.option_type}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Entry Price</TableCell>
                      <TableCell>
                        {trade.entry_price_type === "FLAT"
                          ? trade.entry_price || "-"
                          : `${trade.entry_price_from || "-"} - ${
                              trade.entry_price_to || "-"
                            }`}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Price_Selection_Type</TableCell>
                      <TableCell>
                        {formData.trades[0]?.price_selection_type || "-"}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Target Price</TableCell>
                      <TableCell>{formData.target_amount || "-"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Stop Loss</TableCell>
                      <TableCell>{formData.stop_loss || "-"}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Profit Amount</TableCell>
                      <TableCell>{expected}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>P&L</TableCell>
                      <TableCell>
                        {" "}
                        {formData.trades[0].profit_percent}{" "}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            ),
          )}
        </DialogContent>
        <DialogActions
          sx={{ px: 3, py: 2, borderTop: "1px solid #e2e8f0", gap: 1 }}
        >
          <Button
            onClick={() => setOpenPreview(false)}
            disabled={loadingPreview}
            variant="outlined"
            sx={{
              borderRadius: "7px",
              fontWeight: 600,
              color: "#64748b",
              borderColor: "#cbd5e1",
              "&:hover": { borderColor: "#94a3b8", background: "#f8fafc" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleFinalConfirm}
            disabled={loadingSubmit}
            variant="contained"
            sx={{
              borderRadius: "7px",
              fontWeight: 700,
              background: "linear-gradient(135deg, #16a34a, #15803d)",
              px: 3,
              boxShadow: "0 2px 8px rgba(22,163,74,0.35)",
              "&:hover": {
                background: "linear-gradient(135deg, #15803d, #166534)",
              },
              "&.Mui-disabled": { background: "#94a3b8" },
            }}
          >
            {loadingSubmit ? (
              <CircularProgress size={20} sx={{ color: "#fff" }} />
            ) : (
              "Confirm & Submit"
            )}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Table Card */}
      <Box
        sx={{
          background: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
          border: "1px solid #e2e8f0",
          overflowX: "auto",
          mt: 1,
        }}
      >
        <OptionTable
          futureOptionData={futureOptionData}
          futureOptionLoading={futureOptionLoading}
          refetch={fetchFutureOptionTrade}
          expiryDates={expiryDates}
          tradeFilter={tradeFilter}
        />
        <Box sx={{ borderTop: "1px solid #e2e8f0", px: 2, py: 1 }}>
          <PaginationControls
            totalCount={totalCount}
            page={page}
            setPage={setPage}
            offset={50}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default OptionsDashboard;
